import { createFileRoute } from "@tanstack/react-router";

import { ReportEditorPage } from "../../../workspaces/reports/pages/ReportEditorPage";

export const Route = createFileRoute("/_console/p/$org/$project/reports/$name/edit")({
  component: EditReportRoute,
});

function EditReportRoute() {
  const { name } = Route.useParams();
  return <ReportEditorPage target={{ kind: "saved", name }} />;
}
